export const initialForm = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  company: "",
  address1: "",
  address2: "",
  city: "",
  country: "US",
  state: "",
  zip: "",
  driverCode: ""
};

export const LANDSTAR_IMPORT_SESSION_KEY = "landstarImportAdminAccess";

// Add another normalized year value here when its rewards support personalization.
export const LANDSTAR_PERSONALIZATION_YEARS = Object.freeze(["4"]);

export const wizardSteps = [
  {
    id: "intro",
    label: "Start",
    caption: "Review the redemption flow"
  },
  {
    id: "access",
    label: "Code",
    caption: "Validate your driver code and email"
  },
  {
    id: "rewards",
    label: "Reward",
    caption: "Select eligible reward items"
  },
  {
    id: "checkout",
    label: "Finish",
    caption: "Confirm shipping and submit"
  }
];

export const landstarImportSteps = [
  {
    id: "import",
    label: "Import",
    caption: "Upload eligibility spreadsheet"
  }
];
